import { ForgotPasswordPayload, ForgotPasswordResponse } from "@/app/auth/forgot-password/forgot-password.entity.ts";
import { AuthRepository } from "@/repositories/auth.repository.ts";
import { appUrl } from "@/lib/utils.ts";

export async function forgotPassword(payload: ForgotPasswordPayload): Promise<ForgotPasswordResponse> {
  const redirectTo = appUrl("/reset-password");
  await AuthRepository.resetPasswordForEmail(payload.email, redirectTo);
  
  return {
    success: true,
    message: "Password reset email sent. Please check your inbox.",
  };
}

